import React from "react";
import { Building2, Check, Mail, Medal, Rocket, Shield, Sparkles, TicketCheckIcon, X } from "lucide-react";
import apiClient from "../../../store/shared/api/apiClient";
import { AxiosResponse } from "axios";
import { ErroObj } from "../../../shared/interfaces/model/errorObj.interface";
import { ApiErrorHandler } from "../../../../errorHandler";

const getProductDetailIcon = (status: "Basic" | "Pro" | "Enterprise") => {
  switch (status) {
    case "Basic": return <Shield />;
    case "Pro": return <Rocket />;
    case "Enterprise": return <Sparkles />;
  }
}

const getProductDetailButtonName = (status: "Basic" | "Pro" | "Enterprise") => {
  switch (status) {
    case "Basic": return "Buy Now";
    case "Pro": return "Buy Now";
    case "Enterprise": return "Request for a quote";
  }
};

const productDetailStautsColor = (status: "Basic" | "Standard" | "Pro" | "Enterprise", isBg: boolean = false) => {
  switch (status) {
    case "Basic":
      return isBg ? "bg-sky-100" : "bg-sky-600";
    case "Standard":
      return isBg ? "bg-cyan-100" : "bg-cyan-500";
    case "Pro":
      return isBg ? "bg-green-100" : "bg-green-500";
    case "Enterprise":
      return isBg ? "bg-purple-100" : "bg-purple-500";
  }
};

const productDetailStatusIcons = (status: "Basic" | "Standard" | "Pro" | "Enterprise") => {
  switch (status) {
    case "Basic":
      return <Medal />;
    case "Standard":
      return <X />;
    case "Pro":
      return <Rocket />;
    case "Enterprise":
      return <Shield />;
  }
};


const sendProductInfoRequest = async (body: { name: string, lastname: string, email: string, question: string }, product: string) => {
  const object = {
    requestInfo: true,
    name: body.name,
    lastname: body.lastname,
    email: body.email,
    question: body.question,
    product: product,
  };

  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const URL = `${baseUrl}/nexum-saas/sendInvoiceEmail`;

  return apiClient
    .post(URL, object)
    .then((response: AxiosResponse) => response)
    .catch((e: ErroObj) => {
      ApiErrorHandler(
        e.message,
        e.config.url,
        JSON.stringify(e.config.headers),
        e.config.method
      );
    });
};

export const getOrganizationBaiscFields = () => {
  return ([
    {
      id: "companyName",
      label: "Ragione sociale: ",
      Icon: Building2,
    },
    {
      id: "VAT",
      label: "P.IVA/Tax Number/VAT: ",
      Icon: TicketCheckIcon,
    },
    {
      id: "destinationCode",
      label: "Destination Code: ",
      Icon: TicketCheckIcon,
    },
    {
      id: "pec",
      label: "PEC: ",
      Icon: Mail,
    },
  ]);
}

export { getProductDetailIcon, getProductDetailButtonName, productDetailStautsColor, productDetailStatusIcons, sendProductInfoRequest };


